<!--
  SkipToContent — enlace de salto al contenido (UX-DR38). Visualmente
  oculto hasta recibir foco. Reemplaza a SkipToContentLegacy.
-->

<script setup>
defineOptions({ name: 'DsSkipToContent' });

const props = defineProps({
  target: { type: String, default: 'main' }
});

function onClick(event) {
  event.preventDefault();
  const el = document.getElementById(props.target);
  if (!el) return;
  if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
  el.focus({ preventScroll: false });
  el.scrollIntoView({ behavior: 'auto', block: 'start' });
}
</script>

<template>
  <a
    :href="`#${target}`"
    class="skip-to-content"
    @click="onClick"
  >Skip to content</a>
</template>

<style scoped>
.skip-to-content {
  position: absolute;
  top: var(--space-2);
  left: var(--space-2);
  padding: var(--space-2) var(--space-4);
  background: var(--bg-canvas);
  color: var(--fg-primary);
  border: var(--bw-thin) solid var(--border-default);
  border-radius: var(--radius-md);
  font-size: var(--text-sm);
  font-weight: var(--fw-medium);
  z-index: var(--z-overlay);
  transform: translateY(-200%);
  transition: transform var(--motion-fast) var(--motion-ease-out);
}

.skip-to-content:focus,
.skip-to-content:focus-visible {
  transform: translateY(0);
}
</style>
